import { render, staticRenderFns } from "./GoodsClassList.vue?vue&type=template&id=3b163636&scoped=true&"
import script from "./GoodsClassList.vue?vue&type=script&lang=js&"
export * from "./GoodsClassList.vue?vue&type=script&lang=js&"
import style0 from "./GoodsClassList.vue?vue&type=style&index=0&id=3b163636&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b163636",
  null
  
)

export default component.exports